import { TrustApiError } from '../errors';
import { CreateFormUrl, CreateFormUrlOptions } from '../types';

export const createFormUrlApi = async (apiHost: string, params: CreateFormUrlOptions) => {
    const url = new URL(apiHost);
    url.pathname = '/web/create_form_url';
    url.searchParams.set('service_token', params.serviceToken);

    const response = await fetch(url.toString(), {
        method: 'post',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        body: JSON.stringify({
            anonymously: params.anonymously,
            integration_profile_id: params.integrationProfileId,
            flow: params.flow,
            operation_id: params.operationId,
            theme: params.theme,
            lang: params.lang,
            layout: params.layout,
            method: params.method,
        }),
        credentials: 'include',
    });

    if (!response.ok) {
        throw new TrustApiError(`${response.status} server error`);
    }

    const json: CreateFormUrl = await response.json();

    return json.form_url;
};
